export const MAX_SESSIONS = 5;

export function formatLocation(location) {
  if (!location) return "Unknown";
  const city = location.city;
  const region = location.region || location.state;
  if (city && region) return `${city}, ${region}`;
  return city || region || location.country || "Unknown";
}

export function formatLastActive(lastUsed, isCurrent) {
  if (isCurrent) return "Active now";
  if (!lastUsed) return "Unknown";

  const diffMs = Date.now() - new Date(lastUsed).getTime();
  const minutes = Math.floor(diffMs / 60000);

  if (minutes < 1) return "Active now";
  if (minutes < 60) {
    return `${minutes} minute${minutes === 1 ? "" : "s"} ago`;
  }

  const hours = Math.floor(minutes / 60);
  if (hours < 24) {
    return `${hours} hour${hours === 1 ? "" : "s"} ago`;
  }

  const days = Math.floor(hours / 24);
  return `${days} day${days === 1 ? "" : "s"} ago`;
}
